import axios from 'axios'
import store from '../store'
import { postRequestGateway } from '@/services/api.service'
import * as Sentry from '@sentry/vue'

export async function getRealm(realmId: string) {
  const url = process.env.VUE_APP_API_GW_BASE_URL + `/realms/${realmId}`
  try {
    const { data } = await axios.get(url, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        // @ts-ignore
        Authorization: 'Bearer ' + store.state.oidcStore.access_token
      }
    })
    return data
  } catch (e) {
    console.error(e)
    Sentry.captureException(e)
  }
}

export type Realm = {
  id: string
  name: string
  defaultLocale: string
}

export async function getRealms(): Promise<Realm[] | undefined> {
  const url = process.env.VUE_APP_API_GW_BASE_URL + '/realms'
  try {
    const { data } = await axios.get(url, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        // @ts-ignore
        Authorization: 'Bearer ' + store.state.oidcStore.access_token
      }
    })
    return data
  } catch (e) {
    console.error(e)
    Sentry.captureException(e)
  }
}

export async function postUserLanguage(realmId: string, userId: string, language: string) {
  const endpoint = `${process.env.VUE_APP_API_GW_BASE_URL}/realms/${realmId}/users/${userId}/language/${language}`
  await postRequestGateway(endpoint, {})
}
